import { render } from "./cabina.vue?vue&type=template&id=14c17474"
import script from "./cabina.vue?vue&type=script&lang=js"
export * from "./cabina.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__